module.exports = __webpack_public_path__ + "static/media/bottle.cdc3d62c.svg";